import filters from './filters';

const DOM = {};
let filteredAwards;
let activeFilterYear;

const cacheDOM = () => {
    DOM.awardsList = document.querySelector('.awards__list');
    DOM.showMore = document.querySelector('.awards__more');
    DOM.awardItems = document.querySelectorAll('.awards__item');
    DOM.awardSelect = document.querySelector('.awards__select');
};

const showButton = () => {
    filteredAwards
        .filter((award) => award.classList.contains('awards__item--hide'))
        .slice(0, 3)
        .forEach((award) => award.classList.remove('awards__item--hide'));

    if (
        !filteredAwards.some((x) => x.classList.contains('awards__item--hide'))
    ) {
        DOM.showMore.classList.remove('awards__more--active');
    }
};

const redrawAwardList = () => {
    filteredAwards = [];

    DOM.awardItems.forEach((item) => {
        item.classList.add('awards__item--hide');
        if (
            item.dataset.year === activeFilterYear ||
            activeFilterYear === 'all'
        ) {
            filteredAwards.push(item);
        }
    });

    filteredAwards
        .slice(0, 9)
        .forEach((item) => item.classList.remove('awards__item--hide'));
    if (filteredAwards.length <= 9) {
        DOM.showMore.classList.remove('awards__more--active');
    } else {
        DOM.showMore.classList.add('awards__more--active');
    }
};

const filterByYear = () => {
    const filterYear = DOM.awardSelect.value;
    activeFilterYear = filterYear;

    DOM.awardItems.forEach((item) => {
        const awardYear = item.dataset.year;
        item.classList.add('awards__item--hide');
        if (awardYear === filterYear || filterYear === 'all') {
            item.classList.remove('awards__item--hide');
        }
    });

    redrawAwardList();
};

const handleFilterChange = (e) => {
    filterByYear(e.target.value);
};

const handleShowMore = (e) => {
    e.preventDefault();
    showButton();
};

const bindEvents = () => {
    DOM.showMore.addEventListener('click', handleShowMore);
    DOM.awardSelect.addEventListener('change', handleFilterChange);
};

const init = () => {
    cacheDOM();

    if (DOM.awardsList && DOM.awardSelect) {
        filters.createSelect(DOM.awardSelect);
        activeFilterYear = 'all';
        redrawAwardList();
        bindEvents();
    }
};

const awards = { init };
export default awards;
